<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" />
    </div>
    <div class="content">
      <div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";

export default {
  name: "Employee",
  components: {
    Header,
    Sidebar
  },
  data() {
    return { item: "employee" };
  },
  metaInfo() {
    return {
      title: `Employee Overview - Detailed Insights into Your Workforce`,
      meta: [
        { name: 'description', content: 'Get a comprehensive overview of your employees with HR Desk. Manage employee information, and gain valuable insights into your workforce.' },
        { property: 'og:title', content: 'Employee Overview - Detailed Insights into Your Workforce' },
        { property: 'og:description', content: 'Get a comprehensive overview of your employees with HR Desk. Manage employee information, and gain valuable insights into your workforce.'},
        { property: 'og:type', content: 'employee list' },
        { property: 'og:url', content: 'https://app.hrdesk.africa/employee' },
        { property: 'og:image', content: 'https://uniswitch-public-assets.s3.amazonaws.com/hrdesk-logo-white.png' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Employee Overview - Detailed Insights into Your Workforce' },
        { name: 'twitter:description', content: 'Get a comprehensive overview of your employees with HR Desk. Manage employee information, and gain valuable insights into your workforce.' },
        { name: 'twitter:image', content: 'https://uniswitch-public-assets.s3.amazonaws.com/hrdesk-logo-white.png' },
        { name: 'keywords', content: 'employee overview, employee insights, workforce management, employee tracking, HR analytics' },
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;


  .side-nav {
    width: 10rem;
    position: fixed;
    top: 2rem;
    left: 0;
    bottom: 0;
    background-color: #fff;
    margin-top: 4rem;

    ul {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 10px;
        cursor: pointer;
      }
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
   margin-top: 2rem;
    background: #fbfafa;
    margin-left: 200px;
    height: 100vh;
    overflow: scroll;

    @media (max-width: 768px) {
      margin-left: 0;
      padding: 1rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
    }

  }
}
</style>
